var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51525 16.2815C9.94386 16.2815 10.3661 16.141 10.701 15.8691L15.3412 12.1002C15.7125 11.7997 15.9254 11.3669 15.9254 10.9143C15.9254 10.4617 15.7125 10.0289 15.3421 9.72836L10.701 5.96035C10.1477 5.50958 9.35872 5.41925 8.69077 5.72781C8.10108 6.00149 7.73525 6.54438 7.73525 7.14629L7.73525 14.6823C7.73525 15.2842 8.10108 15.8271 8.69077 16.1008C8.95376 16.2224 9.23587 16.2815 9.51525 16.2815Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2872_7006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 9,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51525 16.2815C9.94386 16.2815 10.3661 16.141 10.701 15.8691L15.3412 12.1002C15.7125 11.7997 15.9254 11.3669 15.9254 10.9143C15.9254 10.4617 15.7125 10.0289 15.3421 9.72836L10.701 5.96035C10.1477 5.50958 9.35872 5.41925 8.69077 5.72781C8.10108 6.00149 7.73525 6.54438 7.73525 7.14629L7.73525 14.6823C7.73525 15.2842 8.10108 15.8271 8.69077 16.1008C8.95376 16.2224 9.23587 16.2815 9.51525 16.2815Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2872_7006)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8404,
    height: 21.465,
    transform: "matrix(-1 0 0 1 21.8405 0.181763)",
    fill: "#0D1C2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowRight);
export default __webpack_public_path__ + "static/media/arrrow-right.e8847243f3ea3bb9e6446da103ca7c4f.svg";
export { ForwardRef as ReactComponent };